<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0" *ngIf="dollar == true">
        <a href="javascript:void(0);" (click)="view()"><span class="mdi mdi-arrow-left"></span></a>
        Edit Sales Target
      </h4>
      <h4 class="mb-0" *ngIf="dollar == false">
        <a href="javascript:void(0);" (click)="view()"><span class="mdi mdi-arrow-left"></span></a>
        Add Sales Target
      </h4>
    </div>

    <div class="card" style="margin-bottom: 260px">
      <div class="card-body">
        <form [formGroup]="registerForm">
          <div class="form-group col-lg-3 col-md-6 col-sm-12 mb-0 d-flex align-items-center px-0" *ngIf="id != 0">
            <label for="" class="font-weight-bold mb-0" style="width: 180px; display: block">Financial Year
            </label>
            <p class="form-control-plaintext">{{ FinancialYear }}</p>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-2 d-flex align-items-center px-0" *ngIf="id == 0">
            <small class="font-weight-bold" style="min-width: 72px">Select Year</small><span
              class="required ml-1 mr-2">*</span>
            <angular2-multiselect style="width: 100%" [data]="YearList" formControlName="FinancialYear"
              [(ngModel)]="selectedYear" [settings]="dropdownSetting" (onSelect)="onYearSelect($event)"
              (onDeSelect)="onYearSelect($event)" (onSelectAll)="onYearSelect($event)"
              (onDeSelectAll)="onYearSelect($event)" fixSearchBug>
            </angular2-multiselect>
          </div>
          <div *ngIf="
              (registerForm.get('FinancialYear').invalid &&
                registerForm.get('FinancialYear').errors &&
                (registerForm.get('FinancialYear').dirty ||
                  registerForm.get('FinancialYear').touched)) ||
              submitted
            ">
            <small class="text-danger" *ngIf="registerForm.get('FinancialYear').hasError('required')">
              Financial Year is required.
            </small>
          </div>

          <div class="form-row px-1">
            <div class="table-responsive">
              <div formArrayName="ObjSalesTarget">
                <table class="table table-bordered mt-1 mytable" aria-hidden="true">
                  <thead class="thead-light">
                    <tr>
                      <th class="font-weight-bold" style="min-width: 70px">
                        Sales Engg Name
                        <span class="required">*</span>
                      </th>
                      <th class="font-weight-bold" style="min-width: 100px; max-width: 140px">
                        Booking Target Value<span class="required ml-1">*</span>
                      </th>
                      <th class="font-weight-bold" style="min-width: 100px; max-width: 180px">
                        Billing Target Value<span class="required ml-1">*</span>
                      </th>
                      <th class="text-center">
                        <span class="mdi mdi-settings"></span>
                      </th>
                    </tr>
                  </thead>

                  <tbody *ngIf="isRender">
                    <tr>
                      <td colspan="1" class="font-weight-bold">TOTAL</td>
                      <td>
                        <span class="form-control-plaintext p-1 text-right mt-0 d-block font-weight-bold"
                          ngDefaultControl style="padding-right: 2px !important" (keyup)="getPrice(i)" type="text"
                          appTwoDigitDecimaNumber min="1" readonly>{{ TotalBooking | number : "1.2-2" }}</span>
                      </td>
                      <td>
                        <span class="form-control-plaintext p-1 text-right mt-0 d-block font-weight-bold"
                          ngDefaultControl style="padding-right: 2px !important" (keyup)="getPrice(i)" type="text"
                          appTwoDigitDecimaNumber min="1" readonly>{{ TotalBilling | number : "1.2-2" }}</span>
                      </td>
                      <td></td>
                    </tr>
                    <ng-container *ngFor="let row of registerForm.controls.ObjSalesTarget.controls;let i = index">
                      <tr [formArrayName]="i" *ngIf="row.controls.Status.value == 1">
                        <td class="p-1 py-1" style="min-width: 115px">
                          <div [ngClass]="{'EditStR': selectedStatus[i] == 2, 'EditStG': selectedStatus[i] == 1}"
                            *ngIf="registerForm.controls.ObjSalesTarget.controls[i].controls.check.value == false">
                            <ng-select [items]="salesEng" bindValue="id" bindLabel="itemName"
                              formControlName="SalesEngineerId" [(ngModel)]="groups[i]"
                              (change)="onDetailSelect($event, i)" placeholder="Select Sales Engineer" [readonly]="true"
                              title="{{ CategoryShow }}">
                            </ng-select>
                          </div>

                          <div [ngClass]="{'EditStR': selectedStatus[i] == 2, 'EditStG': selectedStatus[i] == 1}"
                            *ngIf="registerForm.controls.ObjSalesTarget.controls[i].controls.check.value == true">
                            <ng-select [items]="salesEng" bindValue="id" bindLabel="itemName"
                              formControlName="SalesEngineerId" [(ngModel)]="groups[i]"
                              (change)="onDetailSelect($event, i)" placeholder="Select Sales Engineer"
                              [readonly]="false" title="{{ CategoryShow }}">
                            </ng-select>
                          </div>
                          <div *ngIf="
                              submitted &&
                              registerForm.controls.ObjSalesTarget.controls[i]
                                .controls.SalesEngineerId.errors
                            ">
                            <span style="color: red !important; font-size: 13px">
                              Sales Engineer is required</span>
                          </div>
                        </td>

                        <td class="p-2" hidden>
                          <input type="text" class="form-control" formControlName="Status" [(ngModel)]="rowvalue[i]"
                            hidden />
                        </td>

                        <td class="p-1 py-1">
                          <div>
                            <input type="text" class="form-control p-1 text-right" formControlName="BookingTarget"
                              #BookingTarget placeholder="Booking Target" (input)="
                                parseNUmber($event, i);
                                keyPressNumeric($event, i)
                              " style="padding-right: 10px !important" maxlength="11" max="10000000.00"
                              (keyup)="getPrice(i)" appTwoDigitDecimaNumber (paste)="pasteNumbrother($event, i)"
                              ondrop="return false;" />
                          </div>
                          <div *ngIf="
                              submitted &&
                              registerForm.controls.ObjSalesTarget.controls[i]
                                .controls.BookingTarget.errors
                            ">
                            <span style="color: red !important" class="font-12">
                              Booking Target is required</span>
                          </div>
                        </td>

                        <td class="p-1 py-1">
                          <div>
                            <input type="text" class="form-control p-1 text-right" formControlName="BillingTarget"
                              #BillingTarget placeholder="Billing Target"
                              (input)="parse($event, i); keyPress($event, i)" style="padding-right: 10px !important"
                              maxlength="11" max="10000000.00" (keyup)="getPrice(i)" appTwoDigitDecimaNumber
                              (paste)="pasteNumbr($event, i)" ondrop="return false;" />
                          </div>
                          <div *ngIf="
                              submitted &&
                              registerForm.controls.ObjSalesTarget.controls[i]
                                .controls.BillingTarget.errors
                            ">
                            <span style="color: red !important" class="font-12">
                              Billing Target is required</span>
                          </div>
                        </td>

                        <td class="p-1 font-12">
                          <div ngbDropdown class="d-block list-dropdown-box">
                            <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1"
                              ngbDropdownToggle>
                              <i class="mdi mdi-dots-vertical mdi-24"></i></a>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                              <div>
                                <a href="javascript:void(0);" class="btn dropdown-item" placement="bottom" (click)="
                                    deleteOpenModal(deleteConfirm, i, row.value)
                                  ">
                                  <i class="mdi mdi-delete mr-2"></i> Delete
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>

                    <tr>
                      <td colspan="1">
                        <div class="row justify-content-start align-items-start mb-2 mt-2 zIndexUp">
                          <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0 d-flex">
                            <li>
                              <a href="javascript:void(0);" class="btn btn-sm btn-light-info" (click)="Addrow()">
                                <span class="mdi mdi mdi-plus"></span>
                                Add More</a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row justify-content-start align-items-center mb-2 mt-2 zIndexUp">
            <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0">
              <li>
                <button type="submit" href="javascript:void(0);" class="btn btn-sm btn-light-info" (click)="onSubmit()"
                  [disabled]="multiClick">
                  <span class="mdi mdi-content-save"></span>Save
                </button>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!--Delete modal-->
<ng-template #deleteConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark">
      <strong>Delete Sales Enginner</strong>
    </h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide()" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2" *ngIf="salesEngineer != ''">
      Sales Engineer: <strong>{{ salesEngineer }} ({{ emailId }})</strong>
    </p>
    <p class="text-left mb-2" *ngIf="salesEngineer == ''">
      Do you want to delete this Row ?
    </p>
    <p class="text-left mb-2" *ngIf="salesEngineer != ''">
      Do you want to delete this Sales Enginner ?
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="onDeleteRow(rowId); modalRef.hide()"
      [disabled]="delNameDel">
      Delete
    </button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2" (click)="decline(); modalRef.hide()">
      Cancel
    </button>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>